// src/store/estadisticaStore.js
import apiTamboUrl from "@/services/api";

// Helper para crear acciones de estadísticas con parámetros opcionales
const createStatsAction = (
  endpoint,
  mutationName,
  paramKeys = ["desde", "hasta"]
) => {
  return async ({ commit }, options = {}) => {
    try {
      const params = {};
      paramKeys.forEach((key) => {
        if (options[key] !== undefined && options[key] !== null) {
          params[key] = options[key];
        }
      });
      const response = await apiTamboUrl.get(endpoint, { params });
      commit(mutationName, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error fetching ${endpoint}:`, error);
      throw error;
    }
  };
};

export default {
  namespaced: true,

  state: {
    // Empresas (consolidado: empresas + litros_por_mes + total_ingreso_neto)
    empresasData: null,

    // Siembras e Insumos
    siembras: [],
    insumosSiembra: null,

    // Cosechas y Picados
    cosechas: [],
    picados: [],

    // Vacas
    vacas: null,
    vacasMayorProduccion: null,
    enfermedadesTop: null,
    comparacionLitros: null,
    descartesTop: null,
    tratamientosTop: null,

    // Balanceado
    balanceadoCompra: null,
    balanceadoCampo: null,

    // Inventario Veterinario
    inventarioVeterinario: null,

    // Maquinaria
    maquinas: [],
    maquinaArreglos: null,
    fuelStatus: null,
    fuelStats: null,

    // Dietas
    dietaStats: null,

    // Órdenes de Compra
    ordenesCompra: null,

    // Empleados
    empleados: null,

    // Balance Mensual
    balanceMensual: null,

    // ROI
    roiData: null,

    // Rechazos de Despachos
    rechazosDespachos: null,

    // Inseminaciones
    inseminaciones: null,

    // Forrajeras
    forrajerasStats: null,

    // Estado de carga
    loading: false,
    error: null,
  },

  getters: {
    // Empresas (consolidado)
    empresasData: (state) => state.empresasData,
    empresas: (state) => state.empresasData?.empresas || [],
    litrosPorMes: (state) => state.empresasData?.litros_por_mes || [],
    totalIngresoNeto: (state) => state.empresasData?.total_ingreso_neto || 0,
    razonesRechazo: (state) => state.empresasData?.razones_rechazo || [],
    calidadLeche: (state) =>
      state.empresasData?.calidad_leche || {
        rcs_promedio: state.empresasData?.rcs_promedio || 0,
        ufc_promedio: state.empresasData?.ufc_promedio || 0,
        grasa_promedio: state.empresasData?.grasa_promedio || 0,
        proteina_promedio: state.empresasData?.proteina_promedio || 0,
      },

    // Siembras e Insumos
    siembras: (state) => state.siembras,
    insumosSiembra: (state) => state.insumosSiembra,

    // Cosechas y Picados
    cosechas: (state) => state.cosechas,
    picados: (state) => state.picados,

    // Vacas
    vacas: (state) => state.vacas,
    vacasMayorProduccion: (state) => state.vacasMayorProduccion,
    enfermedadesTop: (state) => state.enfermedadesTop,
    comparacionLitros: (state) => state.comparacionLitros,
    descartesTop: (state) => state.descartesTop,
    tratamientosTop: (state) => state.tratamientosTop,

    // Balanceado
    balanceadoCompra: (state) => state.balanceadoCompra,
    balanceadoCampo: (state) => state.balanceadoCampo,

    // Inventario Veterinario
    inventarioVeterinario: (state) => state.inventarioVeterinario,

    // Maquinaria
    maquinas: (state) => state.maquinas,
    maquinaArreglos: (state) => state.maquinaArreglos,
    fuelStatus: (state) => state.fuelStatus,
    fuelStats: (state) => state.fuelStats,

    // Dietas
    dietaStats: (state) => state.dietaStats,

    // Órdenes de Compra
    ordenesCompra: (state) => state.ordenesCompra,

    // Empleados
    empleados: (state) => state.empleados,

    // Balance Mensual
    balanceMensual: (state) => state.balanceMensual,

    // ROI
    roiData: (state) => state.roiData,

    // Rechazos de Despachos
    rechazosDespachos: (state) => state.rechazosDespachos,

    // Inseminaciones
    inseminaciones: (state) => state.inseminaciones,

    // Forrajeras
    forrajerasStats: (state) => state.forrajerasStats,

    // Estado
    loading: (state) => state.loading,
    error: (state) => state.error,
  },

  mutations: {
    // Empresas (consolidado)
    setEmpresasData: (state, data) => (state.empresasData = data),

    // Siembras e Insumos
    setSiembras: (state, data) => (state.siembras = data),
    setInsumosSiembra: (state, data) => (state.insumosSiembra = data),

    // Cosechas y Picados
    setCosechas: (state, data) => (state.cosechas = data),
    setPicados: (state, data) => (state.picados = data),

    // Vacas
    setVacas: (state, data) => (state.vacas = data),
    setVacasMayorProduccion: (state, data) =>
      (state.vacasMayorProduccion = data),
    setEnfermedadesTop: (state, data) => (state.enfermedadesTop = data),
    setComparacionLitros: (state, data) => (state.comparacionLitros = data),
    setDescartesTop: (state, data) => (state.descartesTop = data),
    setTratamientosTop: (state, data) => (state.tratamientosTop = data),

    // Balanceado
    setBalanceadoCompra: (state, data) => (state.balanceadoCompra = data),
    setBalanceadoCampo: (state, data) => (state.balanceadoCampo = data),

    // Inventario Veterinario
    setInventarioVeterinario: (state, data) =>
      (state.inventarioVeterinario = data),

    // Maquinaria
    setMaquinas: (state, data) => (state.maquinas = data),
    setMaquinaArreglos: (state, data) => (state.maquinaArreglos = data),
    setFuelStatus: (state, data) => (state.fuelStatus = data),
    setFuelStats: (state, data) => (state.fuelStats = data),

    // Dietas
    setDietaStats: (state, data) => (state.dietaStats = data),

    // Órdenes de Compra
    setOrdenesCompra: (state, data) => (state.ordenesCompra = data),

    // Empleados
    setEmpleados: (state, data) => (state.empleados = data),

    // Balance Mensual
    setBalanceMensual: (state, data) => (state.balanceMensual = data),

    // ROI
    setRoiData: (state, data) => (state.roiData = data),

    // Rechazos de Despachos
    setRechazosDespachos: (state, data) => (state.rechazosDespachos = data),

    // Inseminaciones
    setInseminaciones: (state, data) => (state.inseminaciones = data),

    // Forrajeras
    setForrajerasStats: (state, data) => (state.forrajerasStats = data),

    // Estado
    setLoading: (state, value) => (state.loading = value),
    setError: (state, error) => (state.error = error),

    clearAll: (state) => {
      state.empresasData = null;
      state.siembras = [];
      state.insumosSiembra = null;
      state.cosechas = [];
      state.picados = [];
      state.vacas = null;
      state.vacasMayorProduccion = null;
      state.enfermedadesTop = null;
      state.comparacionLitros = null;
      state.balanceadoCompra = null;
      state.balanceadoCampo = null;
      state.inventarioVeterinario = null;
      state.maquinas = [];
      state.maquinaArreglos = null;
      state.fuelStatus = null;
      state.fuelStats = null;
      state.dietaStats = null;
      state.ordenesCompra = null;
      state.empleados = null;
      state.balanceMensual = null;
      state.roiData = null;
      state.rechazosDespachos = null;
      state.inseminaciones = null;
      state.forrajerasStats = null;
    },
  },

  actions: {
    // ============== EMPRESAS (consolidado) ==============
    // /empresas devuelve { empresas, litros_por_mes, total_ingreso_neto }
    // Con agrupar_por_mes=true cada empresa incluye campo 'mensual'
    getEmpresasStats: createStatsAction(
      "/estadisticas/empresas",
      "setEmpresasData",
      ["desde", "hasta", "empresa_id", "turno", "agrupar_por_mes"]
    ),

    // ============== SIEMBRAS E INSUMOS ==============
    getSiembrasStats: createStatsAction(
      "/estadisticas/siembras",
      "setSiembras",
      ["desde_siembra", "hasta_siembra", "material_id"]
    ),
    getInsumosSiembraStats: createStatsAction(
      "/estadisticas/insumos-siembra",
      "setInsumosSiembra",
      ["desde", "hasta", "insumo_id", "siembra_id", "nombre_insumo"]
    ),

    // ============== COSECHAS ==============
    getCosechasStats: createStatsAction(
      "/estadisticas/cosechas",
      "setCosechas",
      ["desde_siembra", "hasta_siembra", "material_id"]
    ),

    // ============== PICADOS ==============
    getPicadosStats: createStatsAction("/estadisticas/picados", "setPicados", [
      "desde",
      "hasta",
      "material_id",
    ]),

    // ============== VACAS ==============
    getVacasStats: createStatsAction("/estadisticas/vacas", "setVacas", [
      "desde",
      "hasta",
    ]),
    getVacasMayorProduccion: createStatsAction(
      "/estadisticas/vaca-mayor-produccion",
      "setVacasMayorProduccion",
      ["limit"]
    ),
    getEnfermedadesTop: createStatsAction(
      "/estadisticas/enfermedades/top",
      "setEnfermedadesTop",
      ["desde", "hasta", "limit", "origen"]
    ),
    getComparacionLitros: createStatsAction(
      "/estadisticas/comparacion-litros",
      "setComparacionLitros",
      [
        "actual_desde",
        "actual_hasta",
        "anterior_desde",
        "anterior_hasta",
        "animal_id",
      ]
    ),
    getDescartesTop: createStatsAction(
      "/estadisticas/descartes/top",
      "setDescartesTop",
      ["desde", "hasta", "limit", "origen"]
    ),
    getTratamientosTop: createStatsAction(
      "/estadisticas/tratamientos/top",
      "setTratamientosTop",
      ["desde", "hasta", "limit", "origen"]
    ),

    // ============== BALANCEADO ==============
    getBalanceadoCompraStats: createStatsAction(
      "/estadisticas/balanceado-compra",
      "setBalanceadoCompra",
      ["desde", "hasta", "material"]
    ),
    getBalanceadoCampoStats: createStatsAction(
      "/estadisticas/balanceado-campo",
      "setBalanceadoCampo",
      ["desde", "hasta", "material_id", "picado_id"]
    ),

    // ============== INVENTARIO VETERINARIO ==============
    getInventarioVeterinarioStats: createStatsAction(
      "/estadisticas/inventario-veterinario",
      "setInventarioVeterinario",
      ["desde", "hasta", "producto"]
    ),

    getMaquinasStats: createStatsAction(
      "/estadisticas/maquinas",
      "setMaquinas",
      ["desde", "hasta"]
    ),

    async getFuelStatus({ commit }) {
      try {
        const response = await apiTamboUrl.get(
          "/maquinaria/combustible/status"
        );
        commit("setFuelStatus", response.data);
        return response.data;
      } catch (error) {
        console.error("Error fetching fuel status:", error);
        throw error;
      }
    },

    async getFuelStats({ commit }) {
      try {
        const response = await apiTamboUrl.get(
          "/maquinaria/combustible/estadisticas"
        );
        commit("setFuelStats", response.data);
        return response.data;
      } catch (error) {
        console.error("Error fetching fuel stats:", error);
        throw error;
      }
    },

    async getMaquinaArreglos(
      { commit },
      { maquinaId, days = 30, start_date, end_date }
    ) {
      try {
        const params = { days };
        if (start_date) params.start_date = start_date;
        if (end_date) params.end_date = end_date;
        const response = await apiTamboUrl.get(
          `/estadisticas/maquinas/${maquinaId}/arreglos`,
          { params }
        );
        commit("setMaquinaArreglos", response.data);
        return response.data;
      } catch (error) {
        console.error("Error fetching maquina arreglos:", error);
        throw error;
      }
    },

    // ============== DIETAS ==============
    async getDietaStats({ commit }, dietaId) {
      try {
        const response = await apiTamboUrl.get(
          `/estadisticas/dietas/${dietaId}`
        );
        commit("setDietaStats", response.data);
        return response.data;
      } catch (error) {
        console.error("Error fetching dieta stats:", error);
        throw error;
      }
    },

    // ============== ÓRDENES DE COMPRA ==============
    getOrdenesCompraStats: createStatsAction(
      "/estadisticas/ordenes_compra",
      "setOrdenesCompra",
      ["desde", "hasta", "top_n"]
    ),

    // ============== EMPLEADOS ==============
    getEmpleadosStats: createStatsAction(
      "/estadisticas/empleados",
      "setEmpleados",
      ["desde", "hasta", "top_n"]
    ),

    // ============== RECHAZOS DE DESPACHOS ==============
    getRechazosDespachos: createStatsAction(
      "/estadisticas/rechazos-despachos",
      "setRechazosDespachos",
      ["desde", "hasta"]
    ),

    // ============== INSEMINACIONES ==============
    getInseminacionesStats: createStatsAction(
      "/estadisticas/inseminaciones-empleados",
      "setInseminaciones",
      ["desde", "hasta"]
    ),

    // ============== FORRAJERAS ==============
    getForrajerasStats: createStatsAction(
      "/estadisticas/forrajeras",
      "setForrajerasStats",
      []
    ),

    // ============== BALANCE MENSUAL ==============
    getBalanceMensual: createStatsAction(
      "/estadisticas/balance-mensual",
      "setBalanceMensual",
      ["anio", "mes", "moneda"]
    ),

    // ============== ROI ==============
    async getRoiStats({ commit }, { anio_a, mes_a, anio_b, mes_b }) {
      try {
        const response = await apiTamboUrl.get("/estadisticas/roi", {
          params: { anio_a, mes_a, anio_b, mes_b },
        });
        commit("setRoiData", response.data);
        return response.data;
      } catch (error) {
        console.error("Error fetching ROI stats:", error);
        throw error;
      }
    },

    // ============== ACCIÓN PARA CARGAR RESUMEN ==============
    async loadResumen({ dispatch, commit }, options = {}) {
      commit("setLoading", true);
      commit("setError", null);

      try {
        await Promise.all([
          dispatch("getBalanceMensual", options),
          dispatch("getEmpresasStats", options),
        ]);
      } catch (error) {
        commit("setError", "Error cargando estadísticas generales");
        console.error("Error loading resumen:", error);
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
